/* Coria · functii in plus pentru selectorul de produse (coria-product-choices).
   Fiecare functie are pornit/oprit in Setari tema → "✦ Selector produse":
   mostre de culoare, cod nuanta, filtre (nude, roz, rosu, glitter, cat-eye...), cautare in orice lista,
   marcaje Nou / Indisponibil / Vazut, pret diferit, unitati consecvente, selectie multipla in cos,
   memorarea filtrului, finisaj, link actualizat, buton de cos sincronizat, nuante asemanatoare. */
(function () {
  'use strict';
  var Choices = window.customElements && customElements.get('coria-product-choices');
  if (!Choices || Choices.prototype.__cfPlus) return;
  Choices.prototype.__cfPlus = true;

  var CFG = window.CORIA_CHOICES || {};
  function on(k) { return CFG[k] !== false; }
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var norm = function (v) { return String(v || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase(); };
  var store = {
    get: function (k, d) { try { var v = localStorage.getItem(k); return v ? JSON.parse(v) : d; } catch (e) { return d; } },
    set: function (k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  };

  /* ---------- vazute recent (handle-uri) ---------- */
  var SEEN_KEY = 'cf_seen_handles';
  var seen = store.get(SEEN_KEY, []);
  function markSeen(h) {
    if (!h) return;
    seen = [h].concat(seen.filter(function (x) { return x !== h; })).slice(0, 60);
    store.set(SEEN_KEY, seen);
  }

  /* ---------- ajutoare ---------- */
  function money(v) {
    var n = parseFloat(v);
    if (!isFinite(n)) return '';
    return n.toFixed(2) + ' Lei';
  }
  function unit(v) {
    var m = String(v || '').trim().match(/^(\d+(?:[.,]\d+)?)\s*(ml|l|g|gr|kg)$/i);
    if (!m) return v;
    var u = m[2].toLowerCase(); u = u === 'gr' ? 'g' : u === 'l' ? 'L' : u;
    return m[1].replace('.', ',') + ' ' + u;
  }
  function code(item) {
    var t = String(item.label || item.title || '');
    var m = t.match(/(?:^|\s|#|nr\.?\s*)(\d{2,4}[a-z]?)\s*$/i) || String(item.title || '').match(/\b(\d{2,4}[a-z]?)\b(?!\s*(?:ml|g|gr|l)\b)/i);
    return m ? m[1] : '';
  }
  function hsl(hex) {
    var m = /^#?([0-9a-f]{6})$/i.exec(hex || ''); if (!m) return null;
    var n = parseInt(m[1], 16), r = (n >> 16 & 255) / 255, g = (n >> 8 & 255) / 255, b = (n & 255) / 255;
    var mx = Math.max(r, g, b), mn = Math.min(r, g, b), l = (mx + mn) / 2, d = mx - mn, h = 0, s = 0;
    if (d) {
      s = d / (1 - Math.abs(2 * l - 1));
      h = mx === r ? ((g - b) / d) % 6 : mx === g ? (b - r) / d + 2 : (r - g) / d + 4;
      h = (h * 60 + 360) % 360;
    }
    return { h: h, s: s, l: l };
  }
  var TONES = [
    ['nude', 'Nude'], ['roz', 'Roz'], ['rosu', 'Rosu'], ['coral', 'Coral / portocaliu'], ['galben', 'Galben'],
    ['verde', 'Verde'], ['albastru', 'Albastru'], ['mov', 'Mov'], ['maro', 'Maro'], ['neutru', 'Alb / negru / gri']
  ];
  function tone(item) {
    var t = norm(item.title + ' ' + (item.label || ''));
    if (/\bnude|natural|beige|bej|cover|french/.test(t)) return 'nude';
    var c = hsl(item.x); if (!c) return '';
    if (c.l < .14 || c.s < .1 || (c.l > .93 && c.s < .3)) return 'neutru';
    if (c.l > .82) return (c.h >= 200 && c.h < 300) ? (c.h < 255 ? 'albastru' : 'mov') : (c.h >= 70 && c.h < 170) ? 'verde' : (c.h < 50 || c.h >= 330) ? (c.s > .55 ? 'roz' : 'nude') : (c.h < 70 ? 'galben' : 'roz');
    if (c.s < .42 && c.l > .55 && (c.h < 50 || c.h > 330)) return 'nude';
    if (c.l < .38 && c.h >= 10 && c.h < 45) return 'maro';
    if (c.h < 12 || c.h >= 345) return c.l > .66 ? 'roz' : 'rosu';
    if (c.h < 45) return c.l > .7 ? 'nude' : 'coral';
    if (c.h < 70) return 'galben';
    if (c.h < 170) return 'verde';
    if (c.h < 255) return 'albastru';
    if (c.h < 300) return 'mov';
    return 'roz';
  }
  function isNew(item) {
    if (!item.d) return false;
    var days = +CFG.newDays || 7;
    return (Date.now() - Date.parse(item.d)) / 864e5 <= days;
  }

  /* ---------- harta handle → optiune ---------- */
  function mapOf(el) {
    if (el.__cfMap) return el.__cfMap;
    var map = new Map(), data = el.catalog || {};
    Object.values(data.groups || {}).forEach(function (g) { (g.items || []).forEach(function (i) { if (i.handle && !map.has(i.handle)) map.set(i.handle, i); }); });
    Object.values(data.families || {}).forEach(function (f) { (f || []).forEach(function (i) { if (i.handle && !map.has(i.handle)) map.set(i.handle, i); }); });
    (el.liveItems || []).forEach(function (i) { var o = map.get(i.handle); map.set(i.handle, o ? Object.assign({}, i, o, { a: i.a, p: i.p, v: i.v, r: i.r, rc: i.rc }) : i); });
    if (el.catalog) el.__cfMap = map;
    return map;
  }

  /* ---------- decorarea fiecarei optiuni ---------- */
  function decorate(el, btn) {
    if (btn.__cfDec) return;
    var item = mapOf(el).get(btn.dataset.handle);
    if (!item) return;
    btn.__cfDec = true;
    var cur = mapOf(el).get(el.dataset.selectedHandle || el.dataset.handle) || {};
    var isShade = !!item.x || /oja|gel|rubber|polygel|pigment/i.test(item.type || '');
    // 1. mostra de culoare reala
    if (on('swatches') && item.x && isShade) {
      var sw = document.createElement('i'); sw.className = 'cfc-sw'; sw.style.setProperty('--sw', item.x); sw.setAttribute('aria-hidden', 'true');
      btn.prepend(sw); btn.classList.add('has-sw');
    }
    var span = btn.querySelector('span:not([class])') || btn.querySelector('span');
    // 2. codul nuantei
    if (on('codes') && isShade && span) {
      var c = code(item);
      if (c && span.textContent.indexOf(c) === -1) { var b = document.createElement('b'); b.className = 'cfc-code'; b.textContent = c; span.prepend(b); }
      else if (c) { span.innerHTML = span.textContent.replace(c, '<b class="cfc-code">' + c + '</b>'); }
    }
    // 8. unitati consecvente
    if (on('units') && !span && /^\s*\d/.test(btn.textContent)) btn.textContent = unit(btn.textContent.trim());
    if (on('units') && span && /^\s*\d+(?:[.,]\d+)?\s*(ml|l|g|gr|kg)\s*$/i.test(span.textContent)) span.textContent = unit(span.textContent.trim());
    var tags = document.createElement('small'); tags.className = 'cfc-tags';
    function tag(txt, cls) { var t = document.createElement('em'); t.className = 'cfc-tag ' + cls; t.textContent = txt; tags.append(t); }
    // 5 / 6 / 10 / 14 marcaje
    if (on('stock') && item.a === 0) { tag('Epuizat', 'is-out'); btn.classList.add('cfc-out'); }
    else if (on('newBadge') && isNew(item)) tag('Nou', 'is-new');
    if (on('finish') && item.f) tag(item.f, 'is-fin');
    if (CFG.reviews === true && +item.r > 0 && +item.rc > 0) tag('★ ' + (+item.r).toFixed(1) + ' (' + item.rc + ')', 'is-rev');
    if (on('seen') && item.handle !== (el.dataset.selectedHandle || el.dataset.handle) && seen.indexOf(item.handle) > -1) tag('Vazut', 'is-seen');
    // 7. pret diferit
    if (on('prices') && item.p && el.classList.contains('cfc-similar')) {
      var card2 = btn.closest('.coria-family-card'), nm = card2 && card2.querySelector('.coria-family-name');
      if (nm && !card2.querySelector('.cfc-card-price')) { var pr = document.createElement('span'); pr.className = 'cfc-card-price'; pr.textContent = money(item.p); nm.after(pr); }
    } else if (on('prices') && item.p && cur.p && Math.abs(parseFloat(item.p) - parseFloat(cur.p)) > .009) tag(money(item.p), 'is-price');
    if (tags.childElementCount) btn.append(tags);
    if (on('quickAdd') && el.classList.contains('cfc-similar') && item.v && item.a !== 0) {
      var card = btn.closest('.coria-family-card');
      if (card && !card.querySelector('.cfc-qa')) {
        var qa = document.createElement('button'); qa.type = 'button'; qa.className = 'cfc-qa';
        qa.setAttribute('aria-label', 'Adauga ' + (item.title || '') + ' in cos'); qa.dataset.cfQa = item.v; qa.textContent = '+';
        card.append(qa);
      }
    }
    btn.dataset.cfTone = tone(item);
    btn.dataset.cfFin = norm(item.f || '');
    btn.dataset.cfFind = norm([item.title, item.label, code(item), item.family, item.f].join(' '));
  }

  /* ---------- filtre, cautare, selectie multipla ---------- */
  function listsOf(el) {
    return [].slice.call(el.querySelectorAll('.coria-shade-list, .coria-family-list, .coria-choice-list:not(.is-volume):not(.coria-collection-list)'));
  }
  function expandAll(list) {
    var block = list.closest('.coria-choice-group');
    var more = block && block.querySelector('.coria-choice-more');
    var guard = 0;
    while (more && !more.hidden && guard++ < 60) more.click();
  }
  function applyFilter(list, state) {
    var q = norm(state.q).trim(), f = state.f;
    if (q || f || state.g) expandAll(list);
    var shown = 0, total = 0;
    list.querySelectorAll('[data-handle]').forEach(function (b) {
      var host = b.closest('.coria-family-card') || b; total++;
      var ok = (!q || (b.dataset.cfFind || norm(b.textContent)).indexOf(q) > -1) && (!state.g || b.dataset.cfFam === state.g) &&
        (!f || (f === 'glitter' ? /glitter|holo|reflect/.test(b.dataset.cfFin) : f === 'magnetic' ? /magnetic/.test(b.dataset.cfFin) : f === 'stoc' ? !b.classList.contains('cfc-out') : b.dataset.cfTone === f));
      host.classList.toggle('cfc-hide', !ok);
      if (ok) shown++;
    });
    var bar = list.__cfBar;
    if (bar) bar.querySelector('.cfc-count').textContent = (q || f || state.g) ? shown + ' rezultate' : '';
  }
  function buildBar(el, list) {
    if (list.__cfBar) return;
    var buttons = list.querySelectorAll('[data-handle]');
    var block = list.closest('.coria-choice-group');
    if (!block || buttons.length < 6) return;
    var withColor = [].filter.call(buttons, function (b) { return b.dataset.cfTone; }).length;
    var typeKey = 'cf_choice_state_' + norm((mapOf(el).get(el.dataset.handle) || {}).type || 'x').replace(/\W+/g, '-');
    var state = on('remember') ? store.get(typeKey, { f: '', q: '' }) : { f: '', q: '' };
    state.q = '';
    var bar = document.createElement('div'); bar.className = 'cfc-bar';
    list.__cfBar = bar;
    // 3. cautare (si in listele care nu aveau)
    if (on('search') && !block.querySelector('.coria-choice-search')) {
      var s = document.createElement('input'); s.type = 'search'; s.className = 'coria-choice-search cfc-search'; s.autocomplete = 'off';
      s.placeholder = 'Cauta dupa numar, nume sau colectie'; s.setAttribute('aria-label', 'Cauta in optiuni');
      s.addEventListener('input', function () { state.q = s.value; applyFilter(list, state); });
      bar.append(s);
    } else if (on('search')) {
      var existing = block.querySelector('.coria-choice-search');
      if (withColor >= 4) existing.placeholder = 'Cauta dupa numar, nume sau colectie';
      existing.addEventListener('input', function () { setTimeout(function () { state.q = existing.value; scan(el); applyFilter(list, state); }, 0); });
    }
    // 4. filtre de culoare si finisaj
    if (on('filters') && withColor >= 4) {
      var chips = document.createElement('div'); chips.className = 'cfc-chips'; chips.setAttribute('role', 'group'); chips.setAttribute('aria-label', 'Filtreaza nuantele');
      var counts = {}; [].forEach.call(buttons, function (b) { counts[b.dataset.cfTone] = (counts[b.dataset.cfTone] || 0) + 1; if (/glitter|holo|reflect/.test(b.dataset.cfFin)) counts.glitter = (counts.glitter || 0) + 1; if (/magnetic/.test(b.dataset.cfFin)) counts.magnetic = (counts.magnetic || 0) + 1; });
      var defs = [['', 'Toate']].concat(TONES.filter(function (t) { return counts[t[0]]; })).concat(counts.glitter ? [['glitter', 'Glitter']] : []).concat(counts.magnetic ? [['magnetic', 'Cat-eye']] : []).concat(on('stock') ? [['stoc', 'In stoc']] : []);
      defs.forEach(function (d) {
        var c = document.createElement('button'); c.type = 'button'; c.className = 'cfc-chip'; c.textContent = d[1]; c.dataset.f = d[0];
        if (d[0] && TONES.some(function (t) { return t[0] === d[0]; })) c.classList.add('cfc-chip--' + d[0]);
        c.setAttribute('aria-pressed', state.f === d[0] ? 'true' : 'false');
        c.addEventListener('click', function () {
          state.f = d[0];
          chips.querySelectorAll('.cfc-chip').forEach(function (x) { x.setAttribute('aria-pressed', x === c ? 'true' : 'false'); });
          if (on('remember')) store.set(typeKey, { f: state.f, q: '' });
          applyFilter(list, state);
        });
        chips.append(c);
      });
      bar.append(chips);
    }
    // 11. selectie multipla
    if (on('multi') && withColor >= 4) {
      var mt = document.createElement('button'); mt.type = 'button'; mt.className = 'cfc-multi-toggle'; mt.setAttribute('aria-pressed', 'false');
      mt.innerHTML = '<i aria-hidden="true"></i>Alege mai multe nuante';
      mt.addEventListener('click', function () { setMulti(el, block, mt.getAttribute('aria-pressed') !== 'true'); mt.setAttribute('aria-pressed', block.classList.contains('cfc-multi') ? 'true' : 'false'); });
      bar.append(mt);
    }
    var count = document.createElement('span'); count.className = 'cfc-count'; count.setAttribute('aria-live', 'polite'); bar.append(count);
    familyChips(el, list, bar, state);
    if (!bar.childElementCount) return;
    list.parentNode.insertBefore(bar, list);
    if (state.f) applyFilter(list, state);
  }

  function setMulti(el, block, onState) {
    block.classList.toggle('cfc-multi', onState);
    var tray = block.querySelector('.cfc-tray');
    if (!onState) { block.querySelectorAll('.cfc-picked').forEach(function (b) { b.classList.remove('cfc-picked'); }); if (tray) tray.remove(); return; }
    if (!tray) {
      tray = document.createElement('div'); tray.className = 'cfc-tray';
      tray.innerHTML = '<span class="cfc-tray__n">Atinge nuantele dorite</span><button type="button" class="cfc-tray__add" disabled>Adauga in cos</button>';
      block.append(tray);
      tray.querySelector('.cfc-tray__add').addEventListener('click', function () { addMany(el, block, tray); });
    }
  }
  function updateTray(block) {
    var tray = block.querySelector('.cfc-tray'); if (!tray) return;
    var n = block.querySelectorAll('.cfc-picked').length;
    tray.querySelector('.cfc-tray__n').textContent = n ? n + (n === 1 ? ' nuanta aleasa' : ' nuante alese') : 'Atinge nuantele dorite';
    var b = tray.querySelector('.cfc-tray__add'); b.disabled = !n; b.textContent = n ? 'Adauga ' + n + ' in cos' : 'Adauga in cos';
  }
  function addMany(el, block, tray) {
    var map = mapOf(el), items = [];
    block.querySelectorAll('.cfc-picked').forEach(function (b) { var it = map.get(b.dataset.handle); if (it && it.v && it.a !== 0) items.push({ id: it.v, quantity: 1 }); });
    if (!items.length) return;
    var btn = tray.querySelector('.cfc-tray__add'); btn.disabled = true; btn.textContent = 'Se adauga...';
    var cart = document.querySelector('cart-drawer'), body = { items: items };
    if (cart && typeof cart.getSectionsToRender === 'function') { body.sections = cart.getSectionsToRender().map(function (s) { return s.section; }); body.sections_url = location.pathname; }
    fetch(root + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok || res.j.status) { tray.querySelector('.cfc-tray__n').textContent = res.j.description || 'Nu am putut adauga.'; return; }
        document.dispatchEvent(new CustomEvent('cart:item-added', { detail: { item: res.j, source: 'cf-choices-multi' } }));
        block.querySelectorAll('.cfc-picked').forEach(function (b) { b.classList.remove('cfc-picked'); });
        tray.querySelector('.cfc-tray__n').textContent = items.length + ' nuante adaugate in cos';
        if (cart && typeof cart.renderContents === 'function' && res.j.sections) { try { cart.renderContents(res.j); if (cart.open) cart.open(); } catch (e) {} }
      })
      .catch(function () { tray.querySelector('.cfc-tray__n').textContent = 'Conexiune intrerupta. Incearca din nou.'; })
      .finally(function () { setTimeout(function () { updateTray(block); }, 2200); });
  }
  document.addEventListener('click', function (ev) {
    var b = ev.target.closest('coria-product-choices .cfc-multi [data-handle]');
    if (!b) return;
    ev.preventDefault(); ev.stopImmediatePropagation();
    var item = mapOf(b.closest('coria-product-choices')).get(b.dataset.handle);
    if (item && item.a === 0) return;
    b.classList.toggle('cfc-picked');
    updateTray(b.closest('.coria-choice-group'));
  }, true);

  /* ---------- adaugare rapida in cos de pe card (fara alta pagina) ---------- */
  document.addEventListener('click', function (ev) {
    var b = ev.target.closest('coria-product-choices [data-cf-qa]');
    if (!b) return;
    ev.preventDefault(); ev.stopImmediatePropagation();
    if (b.disabled) return;
    b.disabled = true; b.classList.add('is-busy');
    var cart = document.querySelector('cart-drawer'), body = { items: [{ id: +b.dataset.cfQa, quantity: 1 }] };
    if (cart && typeof cart.getSectionsToRender === 'function') { body.sections = cart.getSectionsToRender().map(function (s) { return s.section; }); body.sections_url = location.pathname; }
    fetch(root + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok || res.j.status) { b.textContent = '!'; b.title = res.j.description || 'Nu am putut adauga'; return; }
        b.textContent = '✓'; b.classList.add('is-done');
        document.dispatchEvent(new CustomEvent('cart:item-added', { detail: { item: res.j, source: 'cf-choices-quick' } }));
        if (cart && typeof cart.renderContents === 'function' && res.j.sections) { try { cart.renderContents(res.j); if (cart.open) cart.open(); } catch (e) {} }
      })
      .catch(function () { b.textContent = '!'; })
      .finally(function () { b.classList.remove('is-busy'); setTimeout(function () { b.disabled = false; b.textContent = '+'; b.classList.remove('is-done'); }, 2200); });
  }, true);

  /* ---------- scanare dupa fiecare redesenare ---------- */
  function liveStock(el) {
    if (CFG.liveStock !== true || el.__cfLiveBusy) return;
    var todo = [].filter.call(el.querySelectorAll('[data-handle]'), function (b) { return !b.__cfLive; }).slice(0, 24);
    if (!todo.length) return;
    el.__cfLiveBusy = true;
    Promise.all(todo.map(function (b) {
      b.__cfLive = true;
      return fetch(root + 'products/' + encodeURIComponent(b.dataset.handle) + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
        if (!p) return;
        var it = mapOf(el).get(b.dataset.handle); if (it) it.a = p.available ? 1 : 0;
        var cur = b.dataset.handle === (el.dataset.selectedHandle || el.dataset.handle);
        if (!p.available && !cur && CFG.hideOut !== false) (b.closest('.coria-family-card') || b).classList.add('cfc-hide');
        if (p.available) { b.classList.remove('cfc-out'); var t = b.querySelector('.cfc-tag.is-out'); if (t) t.remove(); }
      }).catch(function () {});
    })).then(function () { el.__cfLiveBusy = false; });
  }
  function scan(el) {
    if (!el.catalog) return;
    liveStock(el);
    if (on('units')) {
      el.querySelectorAll('.is-volume button, .coria-family-size:not(.coria-aroma-option)').forEach(function (b) {
        if (b.__cfUnit) return; b.__cfUnit = true;
        var t = b.childElementCount ? null : b.textContent.trim();
        if (t && /^\d+(?:[.,]\d+)?\s*(ml|l|g|gr|kg)$/i.test(t)) b.textContent = unit(t);
      });
      el.querySelectorAll('.coria-choice-status').forEach(function (st) {
        var t = st.textContent, n = t.replace(/(\d+(?:[.,]\d+)?)(ml|l|g|gr|kg)\b/gi, function (m0, a, u) { return unit(a + u); });
        if (n !== t) st.textContent = n;
      });
    }
    el.querySelectorAll('[data-handle]').forEach(function (b) { decorate(el, b); });
    listsOf(el).forEach(function (l) { buildBar(el, l); });
    showFrom(el);
    volumesHint(el);
    if (!el.__cfOutInit) {
      var curIt = mapOf(el).get(el.dataset.selectedHandle || el.dataset.handle);
      var blk0 = el.querySelector('.coria-choice-group');
      if (curIt && blk0 && el.querySelector('[data-handle]')) { el.__cfOutInit = true; if (curIt.a === 0) outBox(el, curIt, blk0); }
    }
  }
  var origConnected = Choices.prototype.connectedCallback;
  Choices.prototype.connectedCallback = async function () {
    var el = this;
    markSeen(el.dataset.handle);
    var mo = new MutationObserver(function () { if (!el.__cfRaf) el.__cfRaf = requestAnimationFrame(function () { el.__cfRaf = 0; scan(el); }); });
    mo.observe(el, { childList: true, subtree: true });
    var r = await origConnected.apply(this, arguments);
    scan(el);
    return r;
  };

  /* ---------- dupa alegere: link, buton de cos, butoanele asistentului ---------- */
  var origSelect = Choices.prototype.selectProduct;
  Choices.prototype.selectProduct = async function (item) {
    var r = await origSelect.apply(this, arguments);
    if (this.dataset.selectedHandle !== item.handle) return r;
    markSeen(item.handle);
    var section = this.closest('.section-main-product') || document;
    if (on('updateUrl') && history.replaceState) {
      try { history.replaceState(history.state, '', root + 'products/' + encodeURIComponent(item.handle) + location.search); } catch (e) {}
    }
    var info = mapOf(this).get(item.handle) || {};
    if (on('syncButton')) {
      section.querySelectorAll('button[name="add"], [data-add-to-cart]').forEach(function (b) {
        var label = b.querySelector('span') || b;
        if (!b.__cfLabel) b.__cfLabel = label.textContent;
        var out = b.disabled || info.a === 0;
        label.textContent = out ? 'Stoc epuizat' : b.__cfLabel;
        b.classList.toggle('cfc-btn-out', out);
      });
    }
    section.querySelectorAll('[data-cf-similar]').forEach(function (b) { b.setAttribute('data-cf-similar', item.handle); });
    section.querySelectorAll('[data-cf-tryon]').forEach(function (b) { b.setAttribute('data-title', item.title || ''); if (info.x) b.setAttribute('data-color', info.x); });
    var blockEl = arguments[1] && arguments[1].closest ? arguments[1].closest('.coria-choice-group') : null;
    var selfEl = this;
    outBox(selfEl, Object.assign({}, info, { title: info.title || item.title }), blockEl);
    fetch(root + 'products/' + encodeURIComponent(item.handle) + '.js').then(function (r) { return r.json(); })
      .then(function (prod) { syncNotify(Object.assign({}, info, { a: prod.available ? 1 : 0 }), prod); }).catch(function () {});
    volumesHint(selfEl);
    document.dispatchEvent(new CustomEvent('coria:product-switched', { detail: { handle: item.handle, item: info } }));
    return r;
  };


  /* ==========================================================================
     Runda 2: ordine, primele vazute, pret "de la", filtru pe gama, nuanta apropiata in stoc,
     "Anunta-ma" la epuizat, aceeasi aroma in alt volum, poza aplicata la apasare lunga
     ========================================================================== */
  function codeNum(item) { var c = code(item); var n = parseInt(c, 10); return isFinite(n) ? n : 1e9; }
  function light(item) { var c = hsl(item.x); return c ? c.l : 2; }
  var TONE_ORDER = ['neutru', 'nude', 'roz', 'rosu', 'coral', 'galben', 'verde', 'albastru', 'mov', 'maro', ''];
  function sortItems(list) {
    if (!Array.isArray(list) || list.length < 3) return list;
    var mode = CFG.sort || 'code';
    if (mode === 'code') list.sort(function (a, b) { return codeNum(a) - codeNum(b) || String(a.title).localeCompare(String(b.title)); });
    else if (mode === 'color') list.sort(function (a, b) { return TONE_ORDER.indexOf(tone(a)) - TONE_ORDER.indexOf(tone(b)) || light(b) - light(a); });
    if (on('seenFirst')) {
      var recent = seen.slice(1, 4); // primul e chiar produsul curent
      list.sort(function (a, b) {
        var ia = recent.indexOf(a.handle), ib = recent.indexOf(b.handle);
        return (ia < 0 ? 99 : ia) - (ib < 0 ? 99 : ib);
      });
    }
    return list;
  }
  function priceSpan(el, list) {
    var ps = (list || []).map(function (i) { return parseFloat(i.p); }).filter(function (n) { return isFinite(n) && n > 0; });
    if (ps.length < 2) return;
    var mn = Math.min.apply(null, ps), mx = Math.max.apply(null, ps);
    if (mx - mn > .009) el.__cfFrom = mn;
  }
  ['addGroup', 'addFamily', 'addCollectionFamily', 'addCleanerFamily'].forEach(function (name) {
    var orig = Choices.prototype[name];
    if (typeof orig !== 'function') return;
    Choices.prototype[name] = function () {
      var args = [].slice.call(arguments), self = this;
      var keep = function (list) {
        if (CFG.hideOut === false || !Array.isArray(list)) return list;
        var cur = self.dataset.selectedHandle || self.dataset.handle;
        return list.filter(function (i) { return i.a !== 0 || i.handle === cur; });
      };
      try {
        if (name === 'addGroup' && args[0] && args[0].items) { args[0] = Object.assign({}, args[0], { items: keep(args[0].items) }); if (args[0].items.length < 2) return; }
        else if (Array.isArray(args[1])) { args[1] = keep(args[1]); }
      } catch (e) {}
      try {
        if (name === 'addGroup' && args[0] && args[0].items && args[0].kind !== 'volume') { sortItems(args[0].items); priceSpan(this, args[0].items); }
        if (name !== 'addGroup' && Array.isArray(args[1])) { sortItems(args[1]); priceSpan(this, args[1]); }
      } catch (e) {}
      return orig.apply(this, args);
    };
  });
  var origFamilyItems = Choices.prototype.familyItems;
  if (typeof origFamilyItems === 'function') {
    Choices.prototype.familyItems = async function () {
      var r = await origFamilyItems.apply(this, arguments);
      try { sortItems(r); } catch (e) {}
      if (CFG.hideOut === false) return r;
      var cur = this.dataset.selectedHandle || this.dataset.handle;
      return r.filter(function (i) { return i.a !== 0 || i.handle === cur; });
    };
  }

  /* 16. pret "de la" langa titlul selectorului */
  function showFrom(el) {
    if (!on('priceFrom') || !el.__cfFrom) return;
    var h = el.querySelector('.coria-choice-heading');
    if (!h || h.querySelector('.cfc-from')) return;
    var s = document.createElement('span'); s.className = 'cfc-from'; s.textContent = 'de la ' + money(el.__cfFrom);
    h.append(s);
  }

  /* 13. filtru pe gama (cand lista are nuante din mai multe game) */
  function familyChips(el, list, bar, state) {
    if (!on('familyChips') || bar.querySelector('.cfc-fam')) return;
    var map = mapOf(el), fams = {};
    list.querySelectorAll('[data-handle]').forEach(function (b) { var it = map.get(b.dataset.handle); if (it && it.family) { fams[it.family] = (fams[it.family] || 0) + 1; b.dataset.cfFam = norm(it.family); } });
    var names = Object.keys(fams);
    if (names.length < 2) return;
    var row = document.createElement('div'); row.className = 'cfc-chips cfc-fam'; row.setAttribute('role', 'group'); row.setAttribute('aria-label', 'Filtreaza dupa gama');
    [''].concat(names).forEach(function (n) {
      var c = document.createElement('button'); c.type = 'button'; c.className = 'cfc-chip cfc-chip--fam';
      c.textContent = n ? n.replace(/\b\w/g, function (x) { return x.toUpperCase(); }) : 'Toate gamele';
      c.setAttribute('aria-pressed', n ? 'false' : 'true');
      c.addEventListener('click', function () {
        state.g = norm(n);
        row.querySelectorAll('.cfc-chip').forEach(function (x) { x.setAttribute('aria-pressed', x === c ? 'true' : 'false'); });
        applyFilter(list, state);
      });
      row.append(c);
    });
    bar.insertBefore(row, bar.firstChild);
  }

  /* 7. cea mai apropiata nuanta in stoc */
  function lab(hex) {
    var m = /^#?([0-9a-f]{6})$/i.exec(hex || ''); if (!m) return null;
    var n = parseInt(m[1], 16), c = [n >> 16 & 255, n >> 8 & 255, n & 255].map(function (v) { v /= 255; return v > .04045 ? Math.pow((v + .055) / 1.055, 2.4) : v / 12.92; });
    var x = (c[0] * .4124 + c[1] * .3576 + c[2] * .1805) / .95047, y = c[0] * .2126 + c[1] * .7152 + c[2] * .0722, z = (c[0] * .0193 + c[1] * .1192 + c[2] * .9505) / 1.08883;
    var f = function (t) { return t > .008856 ? Math.cbrt(t) : 7.787 * t + 16 / 116; };
    return [116 * f(y) - 16, 500 * (f(x) - f(y)), 200 * (f(y) - f(z))];
  }
  function nearestInStock(el, item) {
    var a = lab(item.x); if (!a) return null;
    var best = null, bd = 1e9, fam = null, fd = 1e9;
    mapOf(el).forEach(function (it) {
      if (it.handle === item.handle || it.a === 0 || !it.x || norm(it.type) !== norm(item.type)) return;
      var b = lab(it.x); if (!b) return;
      var d = Math.pow(a[0] - b[0], 2) + Math.pow(a[1] - b[1], 2) + Math.pow(a[2] - b[2], 2);
      if (d < bd) { bd = d; best = it; }
      if (item.family && it.family === item.family && d < fd) { fd = d; fam = it; }
    });
    // intai aceeasi gama (daca e destul de apropiata, deltaE sub ~22), apoi orice gama
    return fam && fd < 484 ? fam : best;
  }
  function outBox(el, item, block) {
    var old = el.querySelector('.cfc-outbox'); if (old) old.remove();
    if (!item || item.a !== 0 || !block) return;
    var box = document.createElement('div'); box.className = 'cfc-outbox';
    var html = '<p class="cfc-outbox__t"><b>' + (item.title || 'Produsul') + '</b> este epuizat momentan.</p>';
    var near = on('nearest') ? nearestInStock(el, item) : null;
    if (near) {
      html += '<button type="button" class="cfc-outbox__near" data-cfc-near="' + near.handle + '"><i class="cfc-sw" style="--sw:' + near.x + '"></i><span>Cea mai apropiata in stoc: <b>' + (code(near) || near.label || near.title) + '</b></span><em>Alege</em></button>';
    }
    if (on('notify') && document.querySelector('[data-back-in-stock]')) html += '<button type="button" class="cfc-outbox__notify" data-cfc-notify>Anunta-ma cand revine</button>';
    box.innerHTML = html;
    block.append(box);
  }
  document.addEventListener('click', function (ev) {
    var n = ev.target.closest('[data-cfc-near]');
    if (n) {
      var el = n.closest('coria-product-choices'), h = n.getAttribute('data-cfc-near');
      var find = function () { return el.querySelector('[data-handle="' + CSS.escape(h) + '"]'); };
      var go = function (t) { t.classList.remove('cfc-hide'); var host = t.closest('.cfc-hide'); if (host) host.classList.remove('cfc-hide'); t.click(); t.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); };
      var target = find();
      if (!target) { var blk = n.closest('.coria-choice-group'); expandAll(blk && blk.querySelector('.coria-shade-list, .coria-family-list, .coria-choice-list:not(.is-volume)') || el); target = find(); }
      if (target) { go(target); return; }
      // nuanta e in alta gama: schimba colectia, apoi alege nuanta
      var it = mapOf(el).get(h), famName = norm(it && it.family);
      var colBtn = [].filter.call(el.querySelectorAll('.coria-collection-option'), function (b) { return norm(b.textContent) === famName; })[0];
      if (!colBtn) { n.querySelector('em').textContent = 'Indisponibil aici'; return; }
      n.disabled = true; n.querySelector('em').textContent = 'Se incarca...';
      colBtn.click();
      var tries = 0, timer = setInterval(function () {
        var t = find();
        if (t || ++tries > 40) { clearInterval(timer); n.disabled = false; if (t) setTimeout(function () { go(t); }, 1200); }
      }, 150);
      return;
    }
    if (ev.target.closest('[data-cfc-notify]')) {
      var f = document.querySelector('[data-back-in-stock]');
      if (f) { f.classList.remove('hidden'); f.hidden = false; f.scrollIntoView({ block: 'center', behavior: 'smooth' }); var i = f.querySelector('input[type="email"]'); if (i) setTimeout(function () { i.focus(); }, 400); }
    }
  });
  /* 6. formularul "Anunta-ma" al temei urmeaza produsul ales */
  function syncNotify(item, product) {
    var f = document.querySelector('[data-back-in-stock]'); if (!f || !on('notify')) return;
    var out = item.a === 0;
    f.classList.toggle('hidden', !out);
    if (!product) return;
    var v = (product.variants || [])[0] || {};
    var set = function (sel, val) { var x = f.querySelector(sel); if (x) x.value = val; };
    set('input[name="contact[Product]"]', product.id);
    set('input[name="contact[Product Title]"]', product.title + (v.title && v.title !== 'Default Title' ? ' - ' + v.title : ''));
    set('input[name="return_to"]', root + 'products/' + product.handle + '?variant=' + v.id + '&contact_posted=true');
  }

  /* 9. aceeasi aroma si in alte volume (cleanere) */
  function volumesHint(el) {
    if (!on('volumesHint')) return;
    var blk = el.querySelector('.coria-cleaner-selector'); if (!blk) return;
    var cur = mapOf(el).get(el.dataset.selectedHandle || el.dataset.handle); if (!cur) return;
    var key = norm(cur.label), vols = [];
    mapOf(el).forEach(function (it) { if (it.handle !== cur.handle && norm(it.label) === key && it.volume && norm(it.volume) !== norm(cur.volume)) vols.push(it); });
    var old = blk.querySelector('.cfc-volhint'); if (old) old.remove();
    if (!vols.length) return;
    vols.sort(function (a, b) { return parseFloat(a.volume) - parseFloat(b.volume); });
    var p = document.createElement('p'); p.className = 'cfc-volhint';
    p.innerHTML = '<span>' + (cur.label || '').replace(/\b\w/g, function (x) { return x.toUpperCase(); }) + ' exista si in:</span>';
    vols.forEach(function (v) {
      var b = document.createElement('button'); b.type = 'button'; b.className = 'cfc-chip'; b.textContent = unit(v.volume) + (v.p ? ' · ' + money(v.p) : '');
      b.addEventListener('click', function () {
        var vb = [].filter.call(blk.querySelectorAll('.coria-cleaner-volumes button'), function (x) { return norm(x.textContent).replace(/\s/g, '') === norm(v.volume).replace(/\s/g, ''); })[0];
        if (vb) vb.click();
      });
      p.append(b);
    });
    var head = blk.querySelector('.coria-aroma-heading');
    (head || blk).after ? (head || blk).after(p) : blk.append(p);
  }

  /* 19. apasare lunga pe o nuanta: poza cu produsul aplicat */
  var pressT = 0, pressed = null, preview = null, suppressClick = false;
  function hidePreview() { clearTimeout(pressT); if (preview) { preview.remove(); preview = null; } }
  function showPreview(btn) {
    var h = btn.dataset.handle; if (!h) return;
    fetch(root + 'products/' + encodeURIComponent(h) + '.js').then(function (r) { return r.json(); }).then(function (p) {
      if (pressed !== btn) return;
      var imgs = (p.media || []).filter(function (m) { return m.media_type === 'image'; });
      var pick = imgs.filter(function (m) { return /aplicat|unghii|manichiura|swatch/i.test(m.alt || ''); })[0] || imgs[1] || imgs[0];
      if (!pick) return;
      suppressClick = true;
      preview = document.createElement('div'); preview.className = 'cfc-preview';
      var src = (pick.src || pick.preview_image && pick.preview_image.src) + ''; src += (src.indexOf('?') > -1 ? '&' : '?') + 'width=480';
      preview.innerHTML = '<img alt="" src="' + src + '"><span>' + (p.title || '') + '</span>';
      document.body.append(preview);
      var r = btn.getBoundingClientRect(), w = 220;
      preview.style.left = Math.max(8, Math.min(innerWidth - w - 8, r.left + r.width / 2 - w / 2)) + 'px';
      preview.style.top = Math.max(8, r.top - 250) + 'px';
    }).catch(function () {});
  }
  document.addEventListener('pointerdown', function (ev) {
    if (!on('preview')) return;
    var b = ev.target.closest('coria-product-choices [data-handle]'); if (!b) return;
    pressed = b; suppressClick = false;
    pressT = setTimeout(function () { showPreview(b); }, 450);
  });
  ['pointerup', 'pointercancel', 'pointerleave', 'scroll'].forEach(function (t) { document.addEventListener(t, function () { pressed = null; hidePreview(); }, true); });
  document.addEventListener('click', function (ev) { if (suppressClick && ev.target.closest('coria-product-choices [data-handle]')) { ev.preventDefault(); ev.stopImmediatePropagation(); suppressClick = false; } }, true);
  document.addEventListener('contextmenu', function (ev) { if (ev.target.closest('coria-product-choices [data-handle]') && on('preview')) ev.preventDefault(); });

  /* selectoarele deja pornite inainte de acest fisier (scriptul selectorului se incarca primul) */
  document.querySelectorAll('coria-product-choices').forEach(function (el) {
    markSeen(el.dataset.handle);
    new MutationObserver(function () { if (!el.__cfRaf) el.__cfRaf = requestAnimationFrame(function () { el.__cfRaf = 0; scan(el); }); }).observe(el, { childList: true, subtree: true });
    scan(el);
  });
})();
